<template>
    <a-modal v-model="visible" title="资信专业信息" width="35%" centered :maskClosable="false" :keyboard="false" class="diyModelCls">
        <a-spin :spinning="loading">
            <vxe-table
                ref="itemTable"
                size="mini"
                resizable
                keep-source
                auto-resize
                row-id="id"
                align="left"
                header-align="center"
                highlight-hover-row
                show-overflow="tooltip"
                :data="editItemData"
                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
            >
                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                <vxe-table-column field="zymc" title="专业名称" width="260"></vxe-table-column>
                <vxe-table-column field="bz" title="备注" width="200"></vxe-table-column>
            </vxe-table>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "ZyxxForm",
    props: ["showMxEdit", "dataId", "zxdjbgid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editItemData: [],
            editDataLoading: false,
            editProps: {
                showMxEdit: false,
                zxdjbgid: null
            }
        };
    },
    computed: {
        visible: {
            get() {
                return this.showMxEdit;
            },
            set(newVal) {
                this.$emit("update:showMxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadItemData();
                }
            },
            immediate: true
        }
    },
    methods: {
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/dwzxbg/listItemZYXX",
                    {
                        zxdjbgid: this.zxdjbgid,
                        sort: {
                            field: "XH",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        }
    }
};
</script>
